export default __webpack_public_path__ + "static/media/julian-timmerman-Fn27DlI8bZ8-unsplash.3aaa0fad.jpg";